import React from 'react'
import {createRoot} from 'react-dom/client'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {ReactQueryDevtools} from '@tanstack/react-query-devtools'
import {ConfigProvider, App as AntdApp} from 'antd'
import arEG from 'antd/locale/ar_EG'
import 'antd/dist/reset.css'
import './config/httpInterceptor'
import App from './App.jsx'
import ToastBridge from './components/ToastBridge.jsx'

// Create a TanStack Query client for backend state and API cache
const queryClient = new QueryClient()

const rootEl = document.getElementById('root')
createRoot(rootEl).render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <ConfigProvider direction="rtl" locale={arEG} theme={{ token: { colorPrimary: '#f55905' } }}>
                <AntdApp>
                    <ToastBridge/>
                    <App/>
                </AntdApp>
            </ConfigProvider>
        </QueryClientProvider>
    </React.StrictMode>
)